import messages from './myDataExport.json' with { type: 'json' };

export const myDataExportSv: Readonly<typeof messages> = messages;
